import InstructorAvailability from "./InstructorAvailability";
import InstructorDetail from "./InstructorDetail";
import InstructorCourse from "./Courses";
import InstructorSessions from "./InstructorSessions";
import InstructorEnrollment from "./InstructorEnrollment";
import { useParams } from "react-router";
import Breadcrumbs from "../../../../global/Breadcrumbs";
import { Col, Container, Row } from "react-bootstrap";
import ControlbarInstructor from "../../../../components/ControlBar/ControlBar.instructor";
import Approvals from "./Approvals";
import Instruments from "./Instruments.tsx";
import PaymentTable from "./payment/Payment.table";
import { useEffect, useState } from "react";
import { AdminService } from "../../../../services/admin.service";
import InstructorService from "../../../../services/instructor.service";
import Profile from "./Profile/Profile.index";
import Availability from "./Availability/Availablility";
import BankAccount from "./BankDetails/Bank";
import Documents from "./Document/document.index";

export default function Instructor() {
  const params: any = useParams();
  const [courses, setCourses] = useState<any>();
  const [instructor, setInstructor] = useState<any>();
  const [tab, setTab] = useState('profile');


  const getDetails = async () => {
    await InstructorService.getDetails(params.id).then((res) => {
      if (res.status === 200) {
        setInstructor(res.data.userData);
      }
    });
  };

  const getCoursesOfInstructor = async () => {
    await AdminService.getCoursesOfInstructorInfo(params.id).then((res) => {
      if (res.status == 200) {
        setCourses(res.data.courses);
      }
    });
  }

  useEffect(() => {
    getDetails();
    getCoursesOfInstructor();
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <div className="m-4">
        <Container>
          <Breadcrumbs
            links={[
              {
                url: "/admin/search",
                name: "Home",
                active: false,
              },
              {
                url: "#",
                name: "Instructor",
                active: true,
              },
            ]}
          />
          <Row className="mt-4">
            <Col md={8}>
              {instructor && <InstructorDetail instructor={instructor} getDetails={getDetails} />}
            </Col>
            <Col md={4}>
              <InstructorAvailability id={params.id} />
              <div className="mt-4">
                <ControlbarInstructor instructorId={params.id} />
              </div>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col md={12}>
              <InstructorCourse id={params.id} />
            </Col>
          </Row>
          <Row className="mt-4">
            <Col>
              <InstructorEnrollment id={params.id} />
            </Col>
          </Row>
          <Row className="mt-4">
            <Col>
              <InstructorSessions id={params.id} />
            </Col>
          </Row>
          <Row className="mt-4">
            <Col>
              <Approvals
                instructor={""}
                courses={""}
                setCourses={""}
                setInstructor={""}
              />
            </Col>
          </Row>
          <Row className="mt-4">
            <Col>
              <Instruments courses={courses} />
            </Col>
          </Row>
          <Row className="mt-4">
            <Col>
              <PaymentTable id={params.id} />
            </Col>
          </Row>
          <Row>
            {instructor &&
              <>
                <div className="header mt-1">
                  <div className="fw-bold fs-grey" style={{fontSize:"35px"}}>Additional Details</div>
                  <div className='mt-2'>
                    <AccountNav tab={tab} setTab={setTab} />
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className='col-12 col-lg-10'>
                    {tab === "profile" && <Profile profile={instructor} setProfile={setInstructor} />}
                    {tab === "documents" && <Documents data={instructor} />}
                    {tab === "bank" && <BankAccount data={instructor.instructor_profile} />}
                    {(tab === "availability") && <Availability data={instructor} />}
                  </div>
                </div>
              </>
            }
          </Row>
        </Container>
      </div>
    </>
  );
}



const AccountNav = ({ tab, setTab }: any) => {
  return (
    <div className="col-auto">
      <ul className="nav nav-tabs  header-tabs">
        <li className="nav-item">
          <div className={`nav-link pointer pt-2 pb-2 px-1 cursor-pointer ${tab === 'profile' && 'active'}`} onClick={() => setTab('profile')}>Profile</div>
        </li>
        <li className="nav-item">
          <div className={`nav-link pointer pt-2 pb-2 px-1 cursor-pointer ${tab === 'documents' && 'active'}`} onClick={() => setTab('documents')}>Documents</div>
        </li>
        <li className="nav-item">
          <div className={`nav-link pointer pt-2 pb-2 px-1 cursor-pointer ${tab === 'availability' && 'active'}`} onClick={() => setTab('availability')}>Availability</div>
        </li>
        <li className="nav-item">
          <div className={`nav-link pointer pt-2 pb-2 px-1 cursor-pointer ${tab === 'bank' && 'active'}`} onClick={() => setTab('bank')}>Bank Account</div>
        </li>
      </ul>
    </div>
  )
}
